import { Record } from 'immutable';
import { FILTER_CHANGE_REMOVAL } from '../constants/overlayTypes';
const FilterChangeRemovalOverlay = Record({
  audit: null,
  filtered: true,
  type: FILTER_CHANGE_REMOVAL
}, 'FilterChangeRemovalOverlay');
export default FilterChangeRemovalOverlay;